<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div id="vesselMain">
          <v-card id="vesselsCard">
            <v-card-title
              id="tableTitle"
              class="primary--text"
              style="font-size: 1.5em; padding: 20px"
              >{{ $t('nav.vessels') }}</v-card-title
            >
            <v-data-table
              id="vesselTable"
              :headers="headers"
              :items="items"
              :items-per-page="-1"  
              class="elevation-0"
            >
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="text-align: left">{{ props.item.vesselCode }}</td>
                  <td style="text-align: left">{{ props.item.description }}</td>
                  <td style="text-align: center">
                    <v-btn
                      id="btnDel"
                      color="primary"
                      x-small
                      fab
                      outlined
                      elevation="1"
                      @click="deleteItemConfirm(props.item)"
                    >
                      <v-icon small color="primary">
                        {{ props.item.isDeleted ? 'lock' : 'lock_open' }}
                      </v-icon>
                    </v-btn>
                    &nbsp;
                    <v-btn
                      id="btnEdit"
                      color="primary"
                      x-small
                      fab
                      outlined
                      elevation="1"
                      :disabled="props.item.isDeleted"
                      @click="editItem(props.item)"
                    >
                      <v-icon small color="primary"> mdi-pencil </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-dialog v-model="dialog" max-width="600px">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-form @submit.prevent="submit" ref="form">
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="editedItem.vesselCode"
                            :rules="[
                              () => !!editedItem.vesselCode || requiredMessage
                            ]"
                            required
                          >
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t('nav.vesselId') }}
                            </template></v-text-field
                          >
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            v-model="editedItem.description"
                            :rules="[
                              () => !!editedItem.description || requiredMessage
                            ]"
                            required
                          >
                            <template v-slot:label>
                              <v-icon color="red" x-small>mdi-asterisk</v-icon>
                              {{ $t('column.description') }}
                            </template></v-text-field
                          >
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close">{{
                    $t('common.cancel')
                  }}</v-btn>
                  <v-btn
                    color="primary"
                    :disabled="!formIsValid"
                    text
                    type="submit"
                    @click="save"
                    >{{ $t('common.save') }}</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-card-actions id="pCardAct">
              <v-fab-transition>
                <v-btn
                  id="btnAddvessel"
                  color="primary"
                  dark
                  small
                  left
                  fab
                  @click="createItem()"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-card-actions>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      dialog: false,
      requiredMessage: this.$t('common.required'),
      headers: [
        {
          text: this.$t('nav.vesselId'),
          align: 'left',
          sortable: true,
          value: 'vesselCode',
          width: '15%'
        },
        {
          text: this.$t('column.description'),
          align: 'left',
          value: 'description'
        },
        {
          text: this.$t('column.actions'),
          align: 'center',
          value: 'opactions',
          sortable: false,
          width: '20%'
        }
      ],
      maxCode: '',

      editedIndex: -1,
      editedItem: {},
      defaultItem: {}
    }
  },
  computed: {
    ...mapGetters(['m_vessel/getNextSeqCode', 'm_vessel/getVessels']),
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('common.new') + ' ' + this.$t('nav.vessels')
        : this.$t('common.edit') + ' ' + this.$t('nav.vessels')
    },
    items() {
      return this['m_vessel/getVessels']
    },
    formIsValid() {
      return this.editedItem.vesselCode && this.editedItem.description
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this['m_vessel/fetchNextMaxCode']()
    this['m_vessel/fetchVessels']()
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.mHideLongLoader()
    })
  },
  methods: {
    ...mapMutations(['mHideLongLoader']),
    ...mapActions([
      'm_vessel/createVessel',

      'm_vessel/fetchNextMaxCode',
      'm_vessel/fetchVessels',

      'm_vessel/updateVessel',
      'm_vessel/deleteVessel'
    ]),

    resetEntity(item) {
      this.editedIndex = item ? this.items.indexOf(item) : -1
      this.editedItem = Object.assign({}, item || this.defaultItem)
    },

    editItem(item) {
      this.resetEntity(item)
      this.dialog = true
    },

    createItem() {
      this.resetEntity()
      this.editedItem.vesselCode = this['m_vessel/getNextSeqCode']
      this.dialog = true
    },

    deleteItemConfirm(item) {
      this.resetEntity(item)

      var msg = this.editedItem.isDeleted ? 'warming.unlock' : 'warming.lock'

      this.$confirm(this.$t(msg) + this.$t('nav.vessels') + '?', {
        buttonTrueText: this.$t('common.ok'),
        buttonFalseText: this.$t('common.cancel'),
        color: 'warning',
        icon: 'warning',
        title: this.$t('common.warning'),
        width: 350,
        property: '$confirm'
      }).then((res) => res && this['m_vessel/deleteVessel'](this.editedItem))
    },

    close() {
      this.$refs.form.resetValidation()
      this.dialog = false
      this['m_vessel/fetchNextMaxCode']()
    },

    save() {
      if (~this.editedIndex) {
        this['m_vessel/updateVessel'](this.editedItem)
      }

      if (!~this.editedIndex) {
        this['m_vessel/createVessel'](this.editedItem)
      }

      this.close()
    }
  }
}
</script>

<style>
#vesselTable {
  margin-left: auto;
  margin-right: auto;
  width: auto;
  height: auto;
}
#vesselTable header {
  font-weight: bold;
}
#vesselsCard {
  width: auto;
}
</style>